import { createContext, useContext } from 'react';

import { generatedListingCardTheme } from './listing-card-theme.generated';

import type { ReactNode } from 'react';

/**
 * Knobs runtime del CardFlat que no son puro CSS — necesitan branch en
 * JSX (icono del CTA, variante del badge, fields de la descripción).
 *
 * Tipografía y colores de título/precio van por CSS (text-style-{slug}
 * + CSS vars `--listing-card-{title,price}-color`), no por aquí.
 *
 * Default desde `listing-card-theme.generated.ts` (theme-config.js).
 * Provider montado en `_app.tsx` cubre todo el árbol.
 */

export type GeneratedListingCardTheme = {
  titleEstiloSlug: string | null;
  priceEstiloSlug: string | null;
  ctaIcon: 'arrow' | 'phone' | 'none';
  badgeStyle: 'pill' | 'markhighlight';
  badgeText: string;
  desc: {
    surface: boolean;
    extras: boolean;
  };
  /** Clase utility para el outer card cuando el tenant pica
   * `listingCardBorderRadius`. `null` → Card atom aplica `rounded-custom`. */
  cardRadiusClass: string | null;
  /** Clase utility (con `!`) para la imagen cuando el tenant pica
   * `listingCardImageBorderRadius`. `null` → Card atom aplica `rounded-t-custom`. */
  imageRadiusClass: string | null;
};

const ListingCardThemeContext = createContext<GeneratedListingCardTheme>(
  generatedListingCardTheme,
);

export const ListingCardThemeProvider = ({
  value,
  children,
}: {
  value?: Partial<GeneratedListingCardTheme> | null;
  children: ReactNode;
}) => (
  <ListingCardThemeContext.Provider
    value={{
      ...generatedListingCardTheme,
      ...(value || {}),
      desc: {
        ...generatedListingCardTheme.desc,
        ...(value?.desc || {}),
      },
    }}
  >
    {children}
  </ListingCardThemeContext.Provider>
);

export const useListingCardTheme = () => useContext(ListingCardThemeContext);
